import { EQTypes } from "./types";

export const gain = {
  default: 0,
  boost: 1,
  cut: -1,
};

export const margin = { top: 0, right: 0, bottom: 0, left: 0 };
export const linePadding = { top: 125, right: 0, bottom: 125, left: 0 };

export const yScaleBottomPadding = (type: EQTypes) =>
  type === "hipass" || type === "lopass" ? 0 : linePadding.bottom;

export const innerCircleRadius = 30;
export const outerCircleRadius = 60;
